<template>
  <div class="container">
    <div class="item">
      <router-link to="analyze/ielts"> 剑桥雅思雅思解析</router-link>
    </div>
    <div class="item">
      <router-link to="analyze/kaoyan"> 考研英语解析</router-link>
    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style>
.container {
  padding: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .item{
    padding: 24px;
    margin: 0 10px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  }
}
</style>
